// extracted by mini-css-extract-plugin
module.exports = {"description":"CustomCopyField_description__1Vfj8"};